@let connectedDropListIds =
  cmsTicketCategoryService.getConnectedDropListIds(ticketCategory().ticketType);
<div
  class="flex h-[calc(100vh-18rem)] flex-col overflow-y-auto rounded-lg border-1"
  [ngClass]="
    isBeingDragged()
      ? 'border-info-main border-2'
      : 'border-standard-outline-light'
  ">
  <div
    cdkDragHandle
    [id]="'header' + ticketCategory().id"
    class="hover:bg-standard-hover-main sticky top-0 flex min-h-25 shrink-0 cursor-grab flex-col"
    (mouseover)="isCategoryHeaderHovered.set(true)"
    (mouseleave)="isCategoryHeaderHovered.set(false)">
    <div class="my-5 flex flex-col items-center gap-2">
      <span
        class="material-symbols-rounded rotate-90"
        [ngClass]="!isCategoryHeaderHovered() ? 'opacity-0' : 'opacity-100'"
        >drag_indicator</span
      >
      <div class="flex w-full flex-row items-center justify-between px-5">
        <div class="flex w-full flex-row items-center">
          <aw-label-text-input
            [isEditing]="isEditing()"
            class="text-standard-text-primary flex w-1/3 text-xl"
            [id]="'category-name' + ticketCategory().id"
            [label]="cmsTextProvider.ticketCategories.categoryName"
            [formControl]="ticketCategoryForm.controls.name" />
        </div>
        <div class="flex w-1/2 flex-row items-center justify-end gap-2">
          <span
            (click)="showSubMenu()"
            class="material-symbols-rounded cursor-pointer"
            [ngClass]="[
              isSubMenuVisible() ? 'border-primary-main rounded-lg border' : '',
              !isCategoryHeaderHovered() ? 'opacity-0' : 'opacity-100',
            ]"
            >more_vert</span
          >
          <span
            (click)="saveNewName()"
            class="material-symbols-rounded cursor-pointer"
            [hidden]="!isEditing()"
            >check</span
          >
          <span
            (click)="cancelName()"
            class="material-symbols-rounded cursor-pointer"
            [hidden]="!isEditing()"
            >close</span
          >
        </div>
        <div class="mt-15 flex justify-end">
          @if (isSubMenuVisible()) {
            <aw-ticket-category-sub-menu
              awCloseOnOffClick
              class="absolute"
              [ticketCategory]="ticketCategory()"
              (onSubmenuClick)="handleSubMenuClick($event)"
              (onOffClick)="hideSubMenu()">
            </aw-ticket-category-sub-menu>
          }
        </div>
      </div>
    </div>
  </div>
  <div
    cdkDropList
    [cdkDropListConnectedTo]="connectedDropListIds"
    [cdkDropListData]="ticketsInCategory"
    [cdkDropListAutoScrollStep]="5"
    (cdkDropListDropped)="dropTicket($event)"
    (cdkDropListEntered)="changePlaceholder(EDropListViewMode.Category)"
    (cdkDropListExited)="changePlaceholder(EDropListViewMode.None)"
    [id]="'category-list-' + ticketCategory().id"
    class="flex h-full flex-col">
    <div class="bg-standard-surface w-full p-3">
      <span class="text-standard-text-primary ml-2">
        {{ cmsTextProvider.ticketCategories.assignedTickets }}
      </span>
    </div>
    @for (ticketInCategory of ticketsInCategory; track $index) {
      <div
        awHoverHighlight
        cdkDrag
        [cdkDragData]="ticketInCategory"
        (cdkDragStarted)="
          toggleTicketDragSignal(true);
          changePlaceholder(EDropListViewMode.Category)
        "
        (cdkDragEnded)="toggleTicketDragSignal(false)"
        class="border-standard-outline-light flex min-h-20 w-full items-center justify-between border-t-1 p-2 transition-transform ease-in-out"
        [ngClass]="
          !isBeingDragged() ? 'hover:bg-standard-hover-main cursor-grab' : ''
        "
        (onHover)="setHighlightedTicket($event, $index)"
        (mouseleave)="setHighlightedTicket(false, $index)">
        <ng-template cdkDragPreview>
          <div
            class="!border-standard-outline-light !flex !justify-center !rounded-lg !border-1 !bg-white !px-10 !py-2">
            {{ ticketInCategory.ticketData?.ticketId }}
          </div>
        </ng-template>
        <ng-template cdkDragPlaceholder>
          @switch (ticketDragAndDropSupportService.currentDropListViewMode()) {
            @case (EDropListViewMode.UnassignedList) {
              <div
                class="border-standard-outline-light hover:bg-standard-hover-main flex min-h-20 w-full cursor-grab items-center justify-between border-t-1 p-2">
                <div [attr.data-testid]="'ticket-' + $index">
                  {{ ticketInCategory.name }}
                </div>
                <span class="material-symbols-rounded mr-5"
                  >drag_indicator</span
                >
              </div>
            }
            @case (EDropListViewMode.Category) {
              <div
                class="border-standard-outline-light hover:bg-standard-hover-main flex min-h-20 w-full cursor-grab items-center justify-between border-t-1 p-2">
                <div [attr.data-testid]="'ticket-' + $index">
                  {{ ticketInCategory.name }}
                </div>
                <div class="flex flex-row items-center justify-end gap-4">
                  <div class="flex flex-col items-center justify-end">
                    <span class="material-symbols-rounded cursor-pointer"
                      >expand_less</span
                    >
                    <span class="material-symbols-rounded">drag_handle</span>
                    <span class="material-symbols-rounded cursor-pointer"
                      >expand_more</span
                    >
                  </div>
                  <span class="material-symbols-rounded mr-5 cursor-pointer"
                    >close</span
                  >
                </div>
              </div>
            }
            @default {
              <div class="min-h-20"></div>
            }
          }
        </ng-template>
        <div
          [attr.data-testid]="
            'ticket-' + ticketInCategory.ticketData?.ticketId
          ">
          {{ ticketInCategory.name }}
        </div>
        <div
          class="flex flex-row items-center justify-end gap-4"
          [ngClass]="
            this.highlightedTicket() === $index ? 'opacity-100' : 'opacity-0'
          ">
          <div class="flex flex-col items-center justify-end">
            <span
              class="material-symbols-rounded cursor-pointer"
              (click)="
                switchTicketsInCategory(
                  ticketInCategory,
                  ESwitchDirection.Backwards
                )
              "
              >expand_less</span
            >
            <span class="material-symbols-rounded">drag_handle</span>
            <span
              class="material-symbols-rounded cursor-pointer"
              (click)="
                switchTicketsInCategory(
                  ticketInCategory,
                  ESwitchDirection.Forwards
                )
              "
              >expand_more</span
            >
          </div>
          <span
            class="material-symbols-rounded mr-5 cursor-pointer"
            (click)="removeCategoryId(ticketInCategory)"
            >close</span
          >
        </div>
      </div>
    }
  </div>

  <div
    class="bg-standard-background sticky bottom-0 mt-auto flex flex-col items-center justify-end gap-1 pb-4 text-center">
    <div class="flex flex-col items-center gap-1 p-3">
      <span class="text-shadow-standard-text-secondary">{{
        cmsTextProvider.ticketCategories.dragAndDrop
      }}</span>
      <span class="text-shadow-standard-text-secondary">{{
        cmsTextProvider.ticketCategories.or
      }}</span>
    </div>
    <span
      class="text-primary-main hover:bg-standard-hover-main flex min-h-10 w-4/5 cursor-pointer items-center justify-center rounded-lg"
      (click)="openCategoryMultiSelectDialog()"
      >{{ cmsTextProvider.ticketCategories.fromList }}</span
    >
  </div>
</div>
